
import {
  solotionTabItems,
  features,
  locations,
  popularServices,
  questions,
} from "~/data/dataResilience";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      copiedIndex: null,
      activeSection: "",
      FormTitle: "",
      solotionTab: 0,
      solotionTabItems,
      features,
      locations,
      popularServices,
      questions,
    };
  },
  components: {
    Modal,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "پایداری داده‌ آبالون | مقیاس‌پذیر، امن و همیشه در دسترس",
      meta: [
        {
          name: "description",
          content:
            "راهکارهای پایداری داده‌ آبالون | ذخیره‌سازی بدون محدودیت |‌ پشتیبان‌گیری امن | بازیابی از بحران (DR) | دسترس‌پذیری پایدار در هر زمان و از هر مکان",
        },
        {
          name: "keywords",
          content: "پایداری داده‌, راهکارهای پایداری داده آبالون",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/data-resilience",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "پایداری داده‌ آبالون | مقیاس‌پذیر، امن و همیشه در دسترس",
        },
        {
          property: "og:description",
          content:
            "راهکارهای پایداری داده‌ آبالون | ذخیره‌سازی بدون محدودیت |‌ پشتیبان‌گیری امن | بازیابی از بحران (DR) | دسترس‌پذیری پایدار در هر زمان و از هر مکان",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/data-resilience",
        },
        {
          name: "twitter:title",
          title: "پایداری داده‌ آبالون | مقیاس‌پذیر، امن و همیشه در دسترس",
        },
        {
          name: "twitter:description",
          content:
            "راهکارهای پایداری داده‌ آبالون | ذخیره‌سازی بدون محدودیت |‌ پشتیبان‌گیری امن | بازیابی از بحران (DR) | دسترس‌پذیری پایدار در هر زمان و از هر مکان",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/data-resilience",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "راهکارهای پایداری داده‌ آبالون چه نقشی در امنیت و تداوم کسب‌وکار دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "این راهکار با ترکیب سه سرویس اصلی شامل آبجکت استوریج، بکاپ ابری و بازیابی از بحران (DR)، زیرساختی پایدار برای ذخیره‌سازی و بازیابی داده‌ها فراهم می‌کند. بدین ترتیب، سازمان‌ها می‌توانند پایداری داده‌ها و تداوم در دسترس بودن سرویس‌های سازمان خود را در برابر خرابی سخت‌افزار، خطای انسانی یا حملات سایبری تضمین کنند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان استفاده از این راهکارها در محیط‌های چندابری یا هیبریدی وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. راهکار پایداری داده‌های آبالون با پشتیبانی از پروتکل‌های استاندارد مانند S3 و سازگاری با زیرساخت‌های متنوع، قابلیت استقرار در محیط‌های چندابری و هیبریدی را دارد. این انعطاف‌پذیری به سازمان‌ها کمک می‌کند متناسب با نیاز خود بهترین معماری پایداری داده و سرویس را پیاده‌سازی کنند.",
                },
              },
              {
                "@type": "Question",
                name: "سرویس بکاپ ابری آبالون چگونه از داده‌ها محافظت می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "این سرویس با پشتیبان‌گیری خودکار، ذخیره‌سازی توزیع‌شده و قابلیت Replication در ریجن‌های مختلف، امنیت و پایداری داده‌ها را تضمین می‌کند. همچنین از مدل‌های متنوع بکاپ مانند Full، Incremental و ترکیبی پشتیبانی کرده و بازیابی سریع داده‌ها را در شرایط بحرانی امکان‌پذیر می‌سازد.",
                },
              },
              {
                "@type": "Question",
                name: "در صورت وقوع بحران یا اختلال، راهکار DR آبالون چه مزیتی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "راهکار DR با بهره‌گیری از بیش از ۲۰ دیتاسنتر فعال در کشور و معماری توزیع‌شده، امکان استقرار Onsite یا Offsite با مدل‌های Active-Active و Active-Passive را فراهم می‌کند. این قابلیت موجب می‌شود سرویس‌های حیاتی سازمان حتی در شرایط بحرانی بدون وقفه در دسترس باقی بمانند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا راهکار پایداری داده‌های آبالون منطبق بر الزامات امنیتی کشور است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "طراحی و پیاده‌سازی این راهکار بر اساس الزامات سازمان پدافند غیرعامل و مرکز مدیریت راهبردی افتا انجام شده است و تمام مؤلفه‌ها با استانداردهای امنیتی هم‌راستا هستند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "خدمات تخصصی دواپس آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
